import { logMessage } from "../logger/logger";
import { LogTypes } from "../logger/logger.typings";

export function convertColor(color: string): string {
  if (color.charAt(0) === "#") {
    return color.substring(1);
  }
  if (color.substring(0, 3) === "rgb") {
    return rgba2hex(color);
  }
  return "";
}

function rgba2hex(color: string) {
  let a;
  const rgb = color
    .replace(/\s/g, "")
    .match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
  const alphaString = ((rgb && rgb[4]) || "").trim();

  if (alphaString !== "") {
    a = parseFloat(alphaString);
  } else {
    a = 1;
  }

  return rgb
    ? subColor2Hex(rgb[1], a) +
        subColor2Hex(rgb[2], a) +
        subColor2Hex(rgb[3], a)
    : color;
}

export function logExportPptFeature() {
  logMessage({
    feature: "Export PPT",
    type: LogTypes.feature,
    description: "Feature export PPT",
    event: "Export PPT event",
    name: "nom",
  });
}

function subColor2Hex(subColor: string, alpha: number): string {
  return Math.round(
    parseInt(subColor, 10) * alpha + 255 * (1 - alpha)
  ).toString(16);
}
